import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Box, CircularProgress, Typography } from '@mui/material';
import tenant from '@/services/TenantService';

export default function M365Callback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get('code');
      const error = searchParams.get('error');

      if (error) {
        toast.error(`Microsoft authentication failed: ${error}`);
        navigate('/admin/interfaces');
        return;
      }

      if (!code) {
        toast.error('No authorization code received');
        navigate('/admin/interfaces');
        return;
      }

      try {
        // Get description and mailbox folder from sessionStorage
        const description =
          sessionStorage.getItem('m365_interface_description') ||
          'M365 Email Interface';
        const mailboxFolder =
          sessionStorage.getItem('m365_mailbox_folder') || 'Inbox';
        sessionStorage.removeItem('m365_interface_description');
        sessionStorage.removeItem('m365_mailbox_folder');

        // Exchange code for tokens and create interface
        await tenant.post(`/interface/m365/callback`, {
          code,
          description,
          mailboxFolder,
        });

        toast.success('M365 interface successfully connected!');
        navigate('/admin/interfaces');
      } catch (error) {
        console.error('M365 callback error:', error);
        toast.error(
          error.response?.data?.message ||
            'Failed to complete M365 authentication',
        );
        navigate('/admin/interfaces');
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: 3,
      }}
    >
      <CircularProgress size={60} />
      <Typography variant="h6" color="text.secondary">
        Completing Microsoft authentication...
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Please wait while we set up your M365 email interface
      </Typography>
    </Box>
  );
}
